import PreviewBackgroundColor from "../colors/PreviewBackgroundColor";

const PAGE_DEFAULT_NAME = "Untitled Page";
const SECTION_DEFAULT_NAME = "Untitled Section";

enum ComponentPageType {
    legacy = "legacy",
    default = "default",
    icon = "icon"
}

enum ComponentSectionType {
    pageSection = "pageSection",
    pageSubsection = "pageSubsection", // refers to legacy groups
    orphanComponentsSection = "orphanComponentsSection"
}

interface ComponentPage {
    _id: string;
    name: string;
    description?: string;
    type: ComponentPageType;
    previewBackgroundColor?: PreviewBackgroundColor;
    componentSections: ComponentSectionReference[];
}

interface ComponentSectionReference {
    id: string;
    order: string;
}

export default ComponentPage;
export {
    ComponentPageType,
    ComponentSectionType,
    ComponentSectionReference,
    PAGE_DEFAULT_NAME,
    SECTION_DEFAULT_NAME
};
